import { MarketComponentTypePlaceholder } from "../../generated/fresh-guard-api";
import parse from "html-react-parser";
import { prepareSvgTemplate } from "../../tools/helpers/SvgTemplateHelper";
import type TemplatePreviewProperties from "./TemplatePreview.properties.ts";

export default function TemplatePreviewView(props: TemplatePreviewProperties) {
  const params = new Map<string, string>();
  params.set(MarketComponentTypePlaceholder.Color, "#F6F6F6");
  params.set(MarketComponentTypePlaceholder.Text, "");

  return (
    <svg
      width="60"
      height="60"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${props.marketComponentType.size?.width} ${props.marketComponentType.size?.height}`}
      preserveAspectRatio="xMidYMid meet"
    >
      {parse(
        prepareSvgTemplate(props.marketComponentType.svgTemplate ?? "", params),
      )}
    </svg>
  );
}
